import { render, staticRenderFns } from "./VuetifyAlert.vue?vue&type=template&id=31f5940c"
import script from "./VuetifyAlert.vue?vue&type=script&lang=js"
export * from "./VuetifyAlert.vue?vue&type=script&lang=js"
import style0 from "./VuetifyAlert.vue?vue&type=style&index=0&id=31f5940c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports